// Rechtstexte für Impressum, Datenschutz und AGB (als Modal-Inhalt)

export const legalDocs = {
  impressum: {
    title: "Impressum",
    subtitle: "Angaben gemäß § 5 DDG (Digitale-Dienste-Gesetz)",
    sections: [
      {
        heading: "Anbieter",
        lines: [
          { text: "MAG Facility Services UG (haftungsbeschränkt)", strong: true },
          { text: "Wemdinger Weg 2" },
          { text: "86154 Augsburg" },
          { text: "Deutschland" },
        ],
      },
      {
        heading: "Vertreten durch",
        lines: [{ text: "Geschäftsführer: Ajdin Mamudov" }],
      },
      {
        heading: "Kontakt",
        lines: [
          { text: "Telefon: 0155 6297 4055" },
          { text: "E-Mail: info@mag-facilityservices.de" },
        ],
      },
      {
        heading: "Registereintrag",
        lines: [
          { text: "Eintragung im Handelsregister" },
          { text: "Registergericht: Amtsgericht Augsburg" },
          { text: "Registernummer: HRB 42472" },
        ],
      },
      {
        heading: "Redaktionell verantwortlich",
        lines: [{ text: "Ajdin Mamudov, Wemdinger Weg 2, 86154 Augsburg" }],
      },
      {
        heading: "EU-Streitschlichtung",
        lines: [
          {
            text:
              "Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit: https://ec.europa.eu/consumers/odr/. Unsere E-Mail-Adresse finden Sie oben im Impressum.",
          },
        ],
      },
      {
        heading: "Verbraucherstreitbeilegung / Universalschlichtungsstelle",
        lines: [
          {
            text:
              "Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.",
          },
        ],
      },
      {
        heading: "Haftung für Inhalte",
        lines: [
          {
            text:
              "Als Diensteanbieter sind wir gemäß § 7 Abs. 1 DDG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 DDG sind wir als Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen.",
          },
        ],
      },
      {
        heading: "Urheberrecht",
        lines: [
          {
            text:
              "Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht. Vervielfältigung, Bearbeitung und Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers.",
          },
        ],
      },
    ],
  },

  datenschutz: {
    title: "Datenschutzerklärung",
    subtitle: "Informationen zur Verarbeitung Ihrer personenbezogenen Daten",
    sections: [
      {
        heading: "1. Datenschutz auf einen Blick",
        lines: [
          {
            text:
              "Die folgenden Hinweise geben einen einfachen Überblick darüber, was mit Ihren personenbezogenen Daten passiert, wenn Sie diese Website besuchen. Personenbezogene Daten sind alle Daten, mit denen Sie persönlich identifiziert werden können.",
          },
        ],
      },
      {
        heading: "2. Verantwortliche Stelle",
        lines: [
          { text: "Verantwortlich für die Datenverarbeitung auf dieser Website ist:" },
          { text: "MAG Facility Services UG (haftungsbeschränkt)", strong: true },
          { text: "Wemdinger Weg 2, 86154 Augsburg" },
          { text: "Telefon: 0155 6297 4055" },
          { text: "E-Mail: info@mag-facilityservices.de" },
        ],
      },
      {
        heading: "3. Ihre Rechte",
        lines: [{ text: "Sie haben jederzeit das Recht:" }],
        list: [
          "Auskunft über Ihre gespeicherten personenbezogenen Daten zu erhalten (Art. 15 DSGVO)",
          "die Berichtigung unrichtiger Daten zu verlangen (Art. 16 DSGVO)",
          "die Löschung Ihrer Daten zu verlangen (Art. 17 DSGVO)",
          "die Einschränkung der Verarbeitung zu verlangen (Art. 18 DSGVO)",
          "der Verarbeitung zu widersprechen (Art. 21 DSGVO)",
          "Ihre Daten übertragen zu lassen (Art. 20 DSGVO)",
        ],
        after: [
          { text: "Zudem steht Ihnen ein Beschwerderecht bei einer Datenschutz-Aufsichtsbehörde zu." },
        ],
      },
      {
        heading: "4. Erfassung von Daten beim Besuch der Website",
        lines: [
          {
            text:
              "Beim Aufrufen unserer Website werden durch den Browser automatisch Informationen an den Server gesendet (z. B. IP-Adresse, Datum und Uhrzeit des Zugriffs, verwendeter Browsertyp). Diese Daten dienen der technischen Bereitstellung und Sicherheit der Website. Rechtsgrundlage ist Art. 6 Abs. 1 lit. f DSGVO.",
          },
        ],
      },
      {
        heading: "5. Kontaktformular",
        lines: [
          {
            text:
              "Wenn Sie uns über das Kontaktformular Anfragen zukommen lassen, werden Ihre Angaben inklusive der angegebenen Kontaktdaten zwecks Bearbeitung der Anfrage bei uns gespeichert. Rechtsgrundlage ist Art. 6 Abs. 1 lit. b und lit. f DSGVO. Die Daten werden gelöscht, sobald sie nicht mehr erforderlich sind.",
          },
        ],
      },
      {
        heading: "6. Cookies",
        lines: [
          {
            text:
              "Unsere Website verwendet nur technisch notwendige Cookies, die für den Betrieb der Seite erforderlich sind. Es werden keine Tracking- oder Marketing-Cookies ohne Ihre Einwilligung gesetzt.",
          },
        ],
      },
      {
        heading: "7. SSL-/TLS-Verschlüsselung",
        lines: [
          {
            text:
              "Diese Seite nutzt aus Sicherheitsgründen eine SSL-/TLS-Verschlüsselung. Eine verschlüsselte Verbindung erkennen Sie an „https://“ in der Adresszeile Ihres Browsers.",
          },
        ],
      },
      {
        heading: "8. Änderung dieser Datenschutzerklärung",
        lines: [
          {
            text:
              "Wir behalten uns vor, diese Datenschutzerklärung anzupassen, damit sie stets den aktuellen rechtlichen Anforderungen entspricht. Es gilt die jeweils aktuelle Fassung.",
          },
        ],
      },
    ],
  },

  agb: {
    title: "Allgemeine Geschäftsbedingungen",
    subtitle: "AGB der MAG Facility Services UG (haftungsbeschränkt)",
    sections: [
      {
        heading: "§ 1 Geltungsbereich",
        lines: [
          {
            text:
              "Diese Allgemeinen Geschäftsbedingungen gelten für alle Verträge über Reinigungs- und Facility-Dienstleistungen zwischen der MAG Facility Services UG (haftungsbeschränkt) und ihren Auftraggebern.",
          },
        ],
      },
      {
        heading: "§ 2 Vertragsschluss & Angebote",
        lines: [
          {
            text:
              "Angebote sind freibleibend. Ein Vertrag kommt durch schriftliche Auftragsbestätigung oder mit Beginn der Leistungsausführung zustande. Der Leistungsumfang ergibt sich aus dem jeweiligen Angebot.",
          },
        ],
      },
      {
        heading: "§ 3 Leistungsumfang",
        lines: [
          {
            text:
              "Art, Umfang und Häufigkeit der Reinigungsleistungen richten sich nach dem vereinbarten Leistungsverzeichnis. Zusätzliche Leistungen werden gesondert vereinbart und berechnet.",
          },
        ],
      },
      {
        heading: "§ 4 Preise & Zahlungsbedingungen",
        lines: [
          {
            text:
              "Es gelten die im Angebot genannten Preise zzgl. der gesetzlichen Umsatzsteuer. Rechnungen sind, sofern nicht anders vereinbart, innerhalb von 14 Tagen ohne Abzug zahlbar.",
          },
        ],
      },
      {
        heading: "§ 5 Haftung & Versicherung",
        lines: [
          {
            text:
              "Wir haften im Rahmen der gesetzlichen Bestimmungen. Für unsere Tätigkeit besteht eine Betriebshaftpflichtversicherung. Schäden sind unverzüglich, spätestens innerhalb von 7 Tagen nach Kenntnis, schriftlich anzuzeigen.",
          },
        ],
      },
      {
        heading: "§ 6 Kündigung",
        lines: [
          {
            text:
              "Dauerschuldverhältnisse können mit einer Frist von vier Wochen zum Monatsende gekündigt werden, sofern nichts anderes vereinbart wurde. Das Recht zur außerordentlichen Kündigung aus wichtigem Grund bleibt unberührt.",
          },
        ],
      },
      {
        heading: "§ 7 Schlussbestimmungen",
        lines: [
          {
            text:
              "Es gilt das Recht der Bundesrepublik Deutschland. Sollten einzelne Bestimmungen unwirksam sein, bleibt die Wirksamkeit der übrigen Bestimmungen unberührt. Gerichtsstand ist, soweit zulässig, Augsburg.",
          },
        ],
      },
    ],
  },
};
